module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Mute-9194fb2960f5afff14d4f012c2b8506b.svg";